import {Module} from "../common/Module";
import {isPrivileged} from "../../config/Privileges";
import {EMPLOYEE_AREA_NAME} from "../users/Employee";
import {Identifier} from "../common/Identifier";
import {TitleDisplayable} from "../common/ComponentBehavioural";
import { Days } from "../calendar/Days";
import {SoftDeletable} from "../common/SoftDeletable";

export const QualificationModule: Module = {
    identifier: "qualifications",
    isPrivileged: ( authUser, privilege) =>
        isPrivileged(
            authUser,
            EMPLOYEE_AREA_NAME,
            QualificationModule.identifier,
            privilege
        )

};

export interface QualificationId {
    qualificationId: Identifier<number>
}

export interface Qualification extends QualificationId, TitleDisplayable, SoftDeletable {
    /**
     * at what interval does the qualification needs to be obtained
     *
     * Important:
     * must be 0 when qualification does not need refreshing
     *
     * */
    refreshRate: Days
}

export type QualificationProp = {
    qualification: Qualification
}

export type QualificationListProp = {
    qualifications: Qualification[]
}